export enum LightingEnum {
  WELL_LIT = "wellLit",
  POORLY_LIT = "poorlyLit",
  UNLIT = "unlit",
  UNKNOWN = "unknown",
  OTHER = "other",
}
